export default __webpack_public_path__ + "assets/images/icon-ai-select.b556c382139c8dff6c2b4631fc49ca20.svg";